export const containsOperators = ['contains', 'does not contain'] as const;
export const isOperators = ['is', 'is not'] as const;
export const stringOperators = ['starts with', 'ends with'] as const;
export const blankOperators = ['is blank', 'is not blank'] as const;
export const isOneOfOperators = ['is one of', 'is not one of'] as const;
export const higherLowerOperators = ['higher than', 'lower than'] as const;
export const isAnyOperators = ['is any'] as const;
export const characterCountOperators = [
  'character count is',
  'character count is not',
  'character count is higher than',
  'character count is lower than'
] as const;
export const regexOperators = [
  'matches regular expression',
  'does not match regular expression'
] as const;
export const timeComparisonOperators = [
  'is before',
  'is after',
  'is before current time',
  'is after current time'
] as const;
export const hideValueOperators = [
  'is blank',
  'is not blank',
  'is any',
  'is today',
  'is before today',
  'is after today',
  'is before current time',
  'is after current time',
  'is today or before',
  'is today or after',
  'is a future date',
  'is not a future date',
  'has changed',
  'user'
] as const;
export const sizeOperators = ['size is less than', 'size is greater than'] as const;
export const fileTypeOperators = ['file type is', 'file type is not'] as const;
export const domainOperators = ['domain must equal', 'domain must not equal'] as const;
export const geocodingOperators = ['near'] as const;

export const defaultOperators = [
  ...containsOperators,
  ...isOperators,
  ...stringOperators,
  ...blankOperators
];
export const numberOperators = [...isOperators, ...higherLowerOperators, ...blankOperators];

// This is just an example on how to define the types for the operators. There are still more operators to be defined. See the v3 builder repo for the full list of operators (https://github.com/knackhq/v3/blob/master/src/util/FieldOperators.js)
export type DefaultOperator = (typeof defaultOperators)[number];
export type NumberOperator = (typeof numberOperators)[number];
